var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "top" } }, [
    _c("div", { staticClass: "innerWrapper" }, [
      _c("h1", [_vm._v("Property selection")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list clear" },
        _vm._l(_vm.datum, function(item, index) {
          return _c("li", { key: index }, [
            _c(
              "span",
              {
                class: {
                  reserved: item.status == "Reserved",
                  sold:
                    item.status == "Sold" ||
                    item.status == "Unconditional" ||
                    item.status == "Settled",
                  available: item.status == "Available",
                  choosed: index == _vm.cur
                },
                on: {
                  click: function($event) {
                    return _vm.choosed(index, item.roomId, item.status)
                  }
                }
              },
              [_vm._v(_vm._s(item.apt))]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "continue",
          class: { disabled: _vm.disable },
          attrs: { disabled: _vm.disable },
          on: { click: _vm.next }
        },
        [_vm._v("\n      Continue\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("\n      Before reserving the property, please select which"),
      _c("br"),
      _vm._v("apartment it is\n      you would like to reserve.\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "allType clear" }, [
      _c("div", { staticClass: "type clear" }, [
        _c("i"),
        _c("span", [_vm._v("Available properties")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "type clear" }, [
        _c("i"),
        _c("span", [_vm._v("Sold properties")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "type clear" }, [
        _c("i"),
        _c("span", [_vm._v("Reserved properties")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-551e2cee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551e2cee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/property/selection.vue
// module id = null
// module chunks = 